import {defineField} from 'sanity'
import {dotcomDocument} from './dotcom.document'
export default defineField({
  title: 'silversea.com Sub Destination',
  name: 'dotcomSubDestination',
  ...dotcomDocument('subDestination'),
  weak: false,
})
